import { useEffect, useState } from 'react';
import type { ParteOdoo } from '../lib/llamadas/parte';
import { fetchParteLlamada } from '../services/llamadas';

// El parte creado en Odoo de la llamada seleccionada, para la tarjeta del
// detalle. Solo se pide cuando la bitácora trae el hito `parte_creado`, y se
// vuelve a pedir si cambia la llamada o ese hito.
//
// El resultado va atado a la clave (llamada + hito) con la que se pidió: al pasar
// a otra llamada no se enseña el parte de la anterior mientras llega el nuevo, y
// una respuesta tardía de la anterior no se cuela en la actual.
export function useParteLlamada(callId: string | null, idHito: string | null): ParteOdoo | null {
  const [dato, setDato] = useState<{ clave: string; parte: ParteOdoo | null } | null>(null);
  const clave = callId && idHito ? `${callId}|${idHito}` : null;

  useEffect(() => {
    if (!callId || !clave) return;
    let vigente = true;
    fetchParteLlamada(callId)
      .then((parte) => {
        if (vigente) setDato({ clave, parte });
      })
      .catch(() => {
        if (vigente) setDato({ clave, parte: null });
      });
    return () => {
      vigente = false;
    };
  }, [callId, clave]);

  return clave !== null && dato?.clave === clave ? dato.parte : null;
}
